import useLogin from "../libs/login/useLogin";
import RecipeList from "../components/Recipe/RecipeList";
import LoginButton from "../components/LoginButton";

export default function Recipes(){
    const {isLoggedIn} = useLogin()
    return <div id="recipes">
        {isLoggedIn ? <RecipeList/> : <LoginButton/>}
    </div>
}